import axios from "../helper/axios";
import { create } from "zustand";

const useSearchJDStore = create((set, get) => ({
  searchedJDdata: [],

  getSearchedJds: async (body) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.post(
        `/jdsearch/${userData.qhoid}/${userData.qhuid}`,
        body
      );
      set({ searchedJDdata: response.data });
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  },

  clearSearchedJds: () => {
    set({ searchedJDdata: [] });
  },
}));

export default useSearchJDStore;
